<template>
  <div class="about page-shell">
    <banner
      title="走进宇飞"
      eyebrow="About Yufei"
      desc="专注云端智慧通行，以产品研发、项目交付和持续运营能力服务城市与商业空间。"
    />

    <section class="section-wrap about-intro">
      <div class="intro-copy">
        <p class="section-kicker">ABOUT US</p>
        <h2 class="section-title">{{ site.company.name }}</h2>
        <p class="section-desc">
          {{ site.company.description }} 公司以“集中管理，云端应用”为核心理念，帮助客户减少本地部署复杂度，提升停车场、门禁、人行通道与车位管理的运营效率。
        </p>
        <div class="contact-card">
          <p>邮箱：{{ site.company.email }}</p>
          <p>电话：{{ site.company.phone }}</p>
          <p>地址：{{ site.company.address }}</p>
        </div>
      </div>
      <div class="intro-visual">
        <img src="../assets/img/jianjietopmin.jpg" alt="宇飞智能" />
      </div>
    </section>

    <section class="timeline-band">
      <div class="section-wrap">
        <div class="section-head section-head--light">
          <div>
            <p class="section-kicker">DEVELOPMENT</p>
            <h2 class="section-title">发展历程</h2>
          </div>
          <p class="section-desc">从设备研发到云端平台，从单点项目到多场景解决方案，持续沉淀通行管理能力。</p>
        </div>
        <div class="timeline-grid">
          <article v-for="item in site.timeline" :key="item.year" class="timeline-card">
            <strong>{{ item.year }}</strong>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <section class="section-wrap honor-section">
      <div class="section-head">
        <div>
          <p class="section-kicker">HONORS</p>
          <h2 class="section-title">公司荣誉</h2>
        </div>
        <p class="section-desc">资质与荣誉是长期研发、交付和服务积累的结果。</p>
      </div>

      <div class="honor-grid">
        <button
          v-for="item in site.honors"
          :key="item.Img"
          class="honor-card"
          @click="openHonor(item)"
        >
          <img v-lazy="item.Img" :alt="item.Remark" />
          <span>{{ item.Remark }}</span>
        </button>
      </div>
    </section>

    <section class="team-section">
      <div class="section-wrap">
        <div class="section-head section-head--light">
          <div>
            <p class="section-kicker">TEAM</p>
            <h2 class="section-title">团队风采</h2>
          </div>
          <p class="section-desc">研发、交付、销售与服务团队协同，为客户项目提供稳定支撑。</p>
        </div>
        <div class="team-grid">
          <img v-for="item in site.teams" :key="item" v-lazy="item" alt="宇飞团队" />
        </div>
      </div>
    </section>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" custom-class="honor-dialog">
      <img class="dialog-img" v-lazy="dialogUrl" :alt="dialogTitle" />
    </el-dialog>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import site from "../static/siteData";

export default {
  name: "GoIn",
  components: {
    Banner
  },
  data() {
    return {
      site,
      dialogVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  methods: {
    openHonor(item) {
      this.dialogUrl = item.Img;
      this.dialogTitle = item.Remark;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.about-intro {
  padding: 76px 0 92px;
  display: grid;
  grid-template-columns: 1fr 0.82fr;
  gap: 54px;
  align-items: center;
}

.intro-copy {
  min-width: 0;
}

.contact-card {
  margin-top: 28px;
  padding: 24px;
  border-radius: 18px;
  color: #314563;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
}

.contact-card p + p {
  margin-top: 12px;
}

.intro-visual {
  position: relative;
  padding: 18px;
  border-radius: 22px;
  background: linear-gradient(135deg, rgba(22, 119, 255, 0.18), rgba(0, 212, 255, 0.08));
}

.intro-visual::after {
  content: "";
  position: absolute;
  right: -24px;
  bottom: -24px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(22, 119, 255, 0.22), transparent 70%);
}

.intro-visual img {
  position: relative;
  z-index: 1;
  width: 100%;
  display: block;
  border-radius: 16px;
  box-shadow: 0 24px 70px rgba(16, 68, 130, 0.16);
}

.timeline-band,
.team-section {
  padding: 82px 0;
  background:
    linear-gradient(135deg, rgba(5, 18, 45, 0.96), rgba(7, 54, 123, 0.94)),
    radial-gradient(circle at 80% 0%, rgba(0, 212, 255, 0.2), transparent 28%);
}

.section-head {
  margin-bottom: 34px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 36px;
}

.section-head .section-desc {
  max-width: 500px;
}

.section-head--light .section-title {
  color: #fff;
}

.section-head--light .section-desc {
  color: #bcd4f6;
}

.timeline-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.timeline-card {
  min-height: 210px;
  padding: 26px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.08);
}

.timeline-card strong {
  color: #8be8ff;
  font-size: 32px;
}

.timeline-card h3 {
  margin-top: 18px;
  color: #fff;
  font-size: 20px;
}

.timeline-card p {
  margin-top: 12px;
  color: #bcd4f6;
  font-size: 14px;
  line-height: 1.8;
}

.honor-section {
  padding: 76px 0 92px;
}

.honor-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.honor-card {
  padding: 14px;
  border: 0;
  border-radius: 18px;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.honor-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 70px rgba(16, 68, 130, 0.14);
}

.honor-card img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 12px;
  background: #eef6ff;
}

.honor-card span {
  display: block;
  min-height: 38px;
  margin-top: 12px;
  color: #314563;
  font-size: 14px;
  font-weight: 800;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.team-grid img {
  width: 100%;
  height: 260px;
  object-fit: cover;
  border-radius: 18px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.16);
}

.dialog-img {
  width: 100%;
  display: block;
}

@media (max-width: 980px) {
  .about-intro,
  .timeline-grid,
  .honor-grid,
  .team-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .section-head {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .about-intro,
  .timeline-grid,
  .honor-grid,
  .team-grid {
    grid-template-columns: 1fr;
  }

  .about-intro,
  .honor-section,
  .timeline-band,
  .team-section {
    padding: 56px 0 70px;
  }
}
</style>
